import React, { useState } from 'react';
import { differenceInSeconds } from 'date-fns';
import ElapsedTimeContext from './context';
const ElapsedTimeProvider = ({ children }) => {
    const [startTime, setStartTime] = useState(() => new Date());
    const resetTimer = () => {
        setStartTime(new Date());
    };
    const getElapsedTime = () => {
        return differenceInSeconds(new Date(), startTime);
    };
    return (React.createElement(ElapsedTimeContext.Provider, { value: { resetTimer, getElapsedTime } }, children));
};
export default ElapsedTimeProvider;
//# sourceMappingURL=ElapsedTimeProvider.js.map